<template>
  <div id="root">
    <div class="fixed-background">
      <main>
        <div class="container">
          <b-row class="h-100">
            <b-colxx xxs="12" md="10" class="mx-auto my-auto">
              <b-card class="auth-card" no-body>
                <div class="position-relative image-side ">
                  <p class=" text-white h2">TableNjoy Brand Admin</p>
                </div>
                <div class="form-side">
                  <h1 class="mb-4" style="color:red">사이트코드를 변경 하셨습니다.<br/>다시 로그인 해주세요.</h1>
                  <p class="mb-0 text-muted text-small mb-0">
                    {{ $t("pages.error-code") }}
                  </p>
                  <p class="display-1 font-weight-bold mb-5">404</p>
                  <span style="color:red">사이트 주소를 모르실 경우 매장 관리자 또는 테이블엔조이 관리자 에게 문의 바랍니다.</span>
                </div>
              </b-card>
            </b-colxx>
          </b-row>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
    },
    mounted: function () {
      document.body.classList.add("background");
    },
    beforeDestroy() {
      document.body.classList.remove("background");
    }
  };
</script>
